interface HttpWaitSignal {
  sendWaitSignal(): void;
  isWaiting(): boolean;
  waitForWaitEndSignal(signalEnd: () => void): void;
  sendWaitEndSignal(): void;
}

function createHttpWaitSignal(): HttpWaitSignal {
  let isWaiting = false;
  let watchers: (() => void)[] = [];

  return {
    sendWaitSignal() {
      isWaiting = true;
    },
    isWaiting() {
      return isWaiting;
    },
    waitForWaitEndSignal(signalEnd) {
      watchers = [...watchers, signalEnd];
    },
    sendWaitEndSignal() {
      isWaiting = false;
      watchers.forEach((signalEnd) => signalEnd());
      watchers = [];
    },
  };
}

export { createHttpWaitSignal };
